import React from 'react';
import s from '../../Feature.module.scss';
import ContentfulImage, { FluidImage } from '../../../../../components/ContentfulImage';
import RichText from '../../../../../components/RichText';
import { CaseStudyFeature } from '../../../../../constants/types';

interface ViewType1Props {
  item: CaseStudyFeature;
}

const ViewType1: React.FC<ViewType1Props> = ({ item }) => {
  const { description, imageSliders, hideTitle, title } = item;

  return (
    <div className={s.root}>
      <div
        className={[s.viewType1, s.container].join(' ')}
        style={{ background: item.backgroundColor || '' }}
        data-testid={'viewtype1-container'}
      >
        <div className={[s.subContainer, s.subContainerRow].join(' ')}>
          <section className={s.textBlockSticky}>
            {!hideTitle && <h2 className={s.title}>{title}</h2>}
            {/* <div className={s.content}>{parse(descriptionHtml || '')}</div> */}
            <div className={s.content}>
              {description && <RichText data={description}/>}
            </div>
          </section>
          <section className={s.imageSection}>
            {item.imageSliders && item.imageSliders.map((img) => 
                <ContentfulImage
                  alt={title || ''}
                  key={img.id}
                  fluid={img?.image?.fluid!}
                  conatainerStyle={{ marginBottom: '7%', boxShadow: '0px 15px 30px -21px #888888' }}
                  dataTestId={'viewType1'}
                />
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ViewType1;
